<template lang="pug">
  .footer
    .container.footer__container
      .footer__logo
        img(
          v-if="lang === 'RU'"
          src="@/assets/images/logo/logo-footer.svg"
        )
        img(
          v-else-if="lang === 'TAT'"
          src="@/assets/images/logo/logo-footer-tat.svg"
        )
      .footer__adress Адрес: Республика Татарстан, г.Казань, ул.Сафьян, д.5
      .footer__social-networks
        social-networks-list(
        :links="socialNetworks"
        )

</template>

<script>
import {mapState} from "vuex";
import SocialNetworksList from "../socialNetworksList/SocialNetworksList";
export default {
  name: "Footer",
  components: {SocialNetworksList},
  props: {
    msg: String
  },
  computed: {
    ...mapState(["lang"])
  },
  data() {
    return {
      socialNetworks: [
        {
          url: "https://vk.com/minmol_rt",
          icon: require("@/assets/images/icons/vk.svg")
        },
        {
          url: "https://www.facebook.com/minmol.rt/",
          icon: require("@/assets/images/icons/fb.svg")
        },
        {
          url: "https://twitter.com/minmol_rt ",
          icon: require("@/assets/images/icons/tw.svg")
        },
        {
          url: "https://www.instagram.com/minmol_rt/ ",
          icon: require("@/assets/images/icons/inst.svg")
        }
      ]
    };
  }
};
</script>
